import React from 'react';

const Hire = () => {
  return (
    <section id="hire" className="hire-container">
      <h1 className="hire-heading">Demandez une prestation</h1>
      <a href="#contact" type="button" className="hire-button">Prendre rendez-vous</a>
    </section>
  );
};

export default Hire;